import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

function AcademicsTab() {
    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }, []);

    return (
        <div className="additional-information">
            <div className="list">
                <ul className="text-start">
                    <li className="text-black">
                        <Link to="/academic-overview" className="text-black">
                            <i className="fa fa-book fa-lg"></i> <span>Academic Overview</span>
                        </Link>
                    </li>
                    <li className="text-black">
                        <Link to="/best-practices" className="text-black">
                            <i className="fas fa-lightbulb"></i> <span>Best Practices</span>
                        </Link>
                    </li>
                    <li className="text-black">
                        <Link to="/institute-distinctiveness" className="text-black">
                            <i className="fas fa-star"></i> <span>Institute Distinctiveness</span>
                        </Link>
                    </li>

                    <Link to="/academic-programs" className="text-black">
                        <li>
                            <i className="fa fa-book fa-lg"></i> <span>Academic Programs</span>
                        </li>
                    </Link>
                    <Link to="/dept/cse" className="text-black">
                        <li>
                            <i className="fa fa-laptop-code fa-lg"></i> <span>CSE Department</span>
                        </li>
                    </Link>
                    <Link to="/dept/cse-ds" className="text-black">
                        <li>
                            <i className="fa fa-database fa-lg"></i> <span>CSD Department</span>
                        </li>
                    </Link>
                    <Link to="/dept/ai-ml" className="text-black">
                        <li>
                            <i className="fa fa-robot fa-lg"></i> <span>CSM Department</span>
                        </li>
                    </Link>
                    <Link to="/dept/ece" className="text-black">
                        <li>
                            <i className="fa fa-plug fa-lg"></i> <span>ECE Department</span>
                        </li>
                    </Link>
                    <Link to="/dept/it" className="text-black">
                        <li>
                            <i className="fa fa-network-wired fa-lg"></i> <span>IT Department</span>
                        </li>
                    </Link>
                    {/* <Link to="/dept/eee" className="text-black">
                        <li>
                            <i className="fa fa-bolt fa-lg"></i> <span>EEE Department</span>
                        </li>
                    </Link> */}
                    <Link to="/dept/mba" className="text-black">
                        <li>
                            <i className="fa fa-briefcase fa-lg"></i> <span>MBA Department</span>
                        </li>
                    </Link>
                    <Link to="/dept/mtech" className="text-black">
                        <li>
                            <i className="fa fa-cogs fa-lg"></i> <span>M.Tech Department</span>
                        </li>
                    </Link>
                    <Link to="/dept/s-and-h" className="text-black">
                        <li>
                            <i className="fa fa-users fa-lg"></i> <span>S&H Department</span>
                        </li>
                    </Link>
                    <Link to="/e-learning-resources" className="text-black">
                        <li>
                            <i className="fa fa-chalkboard-teacher fa-lg"></i> <span>E-Learning Resources</span>
                        </li>
                    </Link>
                    <Link to="/dept/dpe" className="text-black">
                        <li>
                            <i className="fa fa-futbol fa-lg"></i> <span>Department of Physical Education</span>
                        </li>
                    </Link>
                    <Link to="/dept/library" className="text-black">
                        <li>
                            <i className="fa fa-book-reader fa-lg"></i> <span>Central Library</span>
                        </li>
                    </Link>
                </ul>
            </div>
        </div>
    );
}

export default AcademicsTab;
